var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoInitialWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 592.92 238.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#17a6c9;}.cls-3{fill:#f6e748;}.cls-4{fill:#f16079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "206.74 119.36 137.83 0 68.91 119.36 0 238.72 64.14 238.72 68.91 230.46 78.43 213.97 162.76 214.16 130.77 158.66 110.42 158.56 137.83 111.1 206.74 230.46 211.51 238.72 275.65 238.72 206.74 119.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "349.34 0 211.51 238.72 275.65 238.72 381.75 56.15 349.34 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "349.25 0.17 487.08 238.89 422.94 238.89 316.84 56.31 349.25 0.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "423.02 238.89 487.16 238.89 592.92 55.72 560.85 0.17 423.02 238.89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoInitialWhite);
export default __webpack_public_path__ + "static/media/logo-initial-white.05b6edadec23b52b612ad70a3eb53a91.svg";
export { ForwardRef as ReactComponent };